import Load from 'components/Load';
import PrivateHostRoute from 'components/PrivateHostRoute';
import FeatureFlags from 'featureFlags';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import React from 'react';
import basePath from 'utils/basePath';
import { isCordova } from 'utils/platform';

const AsyncHostHomePageContainer = Load(
  () =>
    import(
      /* webpackChunkName: "host-homescreen" */ './containers/HostHomePageContainer'
    ),
);
const AsyncHostHome = Load(
  () => import(/* webpackChunkName: "host-homescreen" */ './pages/HostHome'),
);
const AsyncScheduleBreak = Load(
  () =>
    import(
      /* webpackChunkName: "host-homescreen" */ '../host/components/HostScheduleBreak/ScheduleBreak'
    ),
);
const AsyncGoOffline = Load(
  () =>
    import(
      /* webpackChunkName: "host-homescreen" */ '../host/components/HostStatus/GoOffline'
    ),
);
const AsyncHostStatus = Load(
  () =>
    import(
      /* webpackChunkName: "host-homescreen" */ '../host/components/HostStatus'
    ),
);
const AsyncFeedbackContainer = Load(
  () =>
    import(
      /* webpackChunkName: "host-homescreen" */ './containers/FeedbackContainer'
    ),
);
const AsyncHostDashboardContainer = Load(
  () =>
    import(
      /* webpackChunkName: "host-homescreen" */ './containers/HostDashboardContainer'
    ),
);

const hasHostStatusFeatureFlag = FeatureFlags.isSet(
  FeatureFlags.flags.HOST_STATUS,
);

const hostHomePageRoute = [
  hasHostStatusFeatureFlag ? (
    <PrivateHostRoute
      key="host-homepage"
      path={`${basePath}/host/home`}
      hideFooter
      component={AsyncHostHome}
      showBottomNavigation
      noNavbar={isCordova()}
      showSearchInNavbar={false}
    />
  ) : (
    <NavigationableLayout
      key="host-homepage"
      path={`${basePath}/host/home`}
      hideFooter
      component={AsyncHostHomePageContainer}
      showBottomNavigation
      noNavbar={isCordova()}
      nonFixedNavbar
      showSearchInNavbar={false}
    />
  ),
  <PrivateHostRoute
    key="host-break"
    path={`${basePath}/host/schedule-break/:action?`}
    hideFooter
    component={AsyncScheduleBreak}
    onTopOf={AsyncHostHome}
    showBottomNavigation
    noNavbar={isCordova()}
    showSearchInNavbar={false}
  />,
  <PrivateHostRoute
    key="host-offline"
    path={`${basePath}/host/status/:state?`}
    hideFooter
    component={AsyncHostStatus}
    onTopOf={AsyncHostHome}
    showBottomNavigation
    noNavbar={isCordova()}
    showSearchInNavbar={false}
  />,
  <PrivateHostRoute
    key="host-offline"
    path={`${basePath}/host/go-offline`}
    hideFooter
    component={AsyncGoOffline}
    onTopOf={AsyncHostHome}
    showBottomNavigation
    noNavbar={isCordova()}
    showSearchInNavbar={false}
  />,
  <NavigationableLayout
    key="host-feedback"
    path={`${basePath}/host/feedback`}
    hideFooter
    component={AsyncFeedbackContainer}
    showBottomNavigation
    noNavbar={isCordova()}
    nonFixedNavbar
  />,
  <NavigationableLayout
    key="host-dashboard"
    path={`${basePath}/host/dashboard`}
    hideFooter
    component={AsyncHostDashboardContainer}
    showBottomNavigation
    noNavbar={isCordova()}
    nonFixedNavbar
  />,
];

export default hostHomePageRoute;
